import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ItemsContext = createContext();

export const ItemsProvider = ({
  streams = [],
  selectedCameras = [],
  // cameras is needed in addition to selectedCameras to check for network address duplicates
  cameras = [],
  zones = [],
  children,
}) => {
  const contextValue = {
    streams,
    selectedCameras,
    cameras,
    zones,
  };

  return (
    <ItemsContext.Provider value={contextValue}>
      {children}
    </ItemsContext.Provider>
  );
};

ItemsProvider.propTypes = {
  streams: PropTypes.array.isRequired,
  selectedCameras: PropTypes.array.isRequired,
  cameras: PropTypes.array.isRequired,
  zones: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
};

export const useItems = () => {
  return useContext(ItemsContext);
};